// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonAnchor-module--button--937b9a","medium":"ButtonAnchor-module--medium--cbb0ac","icon":"ButtonAnchor-module--icon--d118ed"};